import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Form } from 'react-redux-form';
import CustomSearchableSelectWrapper from '../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField
} from "../../../../common/custom-form/select-filter.component";
import { withRouter } from 'react-router-dom';
import { inventoryEquipmentActions } from "../../../../../store/external/inventory/equipment.reducer";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component"; 
import { Loading } from "../../../../common/loading";
import {
    DATA_TYPE
    , PLACEHOLDER
    , MODAL_TITLE
    , EQUIPMENT_MSG
    , MAX_LENGTH
    , OPTION_LABEL
    , DISPLAY_OPTION
} from "../../../../../constants/external-constants";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { convertToDecimal, isObjectEqual } from '../../../../../utils/helpers.utils';


class FormView extends Component {  
    constructor(props) {
        super(props);

        this.state = {
            showNotif: false,
            isSaving: false,
            notifTitle: null,
            showValidationModal: false,
            showModal: false,
            updateEquipment: false,
            modalMessage: "",
            loading: true,
            exitForm: false,
            isError: false,
            isRequiredNotEmpty: false,
            acceptConf: false,
            defaultCompanyCode: []
        }
        this.handleDisableSaveButton = this.handleDisableSaveButton.bind();
        this.getCompanyCodeOption = this.getCompanyCodeOption.bind();
    }

    

    componentDidMount() {
        window.scrollTo(0, 0);
        let defaultCompanyCode = this.props.inventoryEquipment.inventoryEquipmentDropdownList.CompanyCodes
            .map((data, index) => {return {Key: index + 1, Value: data} });
        this.setState({
            defaultCompanyCode: defaultCompanyCode
        });        
    }


    handleConfirmationModal = async (buttonType) => {
        this.setState({ acceptConf: true });
        const { submitRequest, checkDuplicate, inventoryEquipmentForm } = this.props;
        const isUpdate = inventoryEquipmentForm.equipmentId > 0 ? true : false;
        var processMessage = isUpdate
            ? EQUIPMENT_MSG.UPDATED_MSG
            : EQUIPMENT_MSG.CREATED_MSG;
            
        if(buttonType === "ok" && !this.handleDisableSaveButton()) {
            var duplicateData = await checkDuplicate();
            if (duplicateData && duplicateData.EquipmentId > 0 && duplicateData.EquipmentId !== inventoryEquipmentForm.equipmentId) {
                this.setState( prev => ({
                        notifTitle: MODAL_TITLE.ERROR,
                        showModal: false,
                        isError: true,
                        showValidationModal: true,
                        modalMessage: EQUIPMENT_MSG.EXISTS_MSG,
                        exitForm: false,
                        isSaving: false
                    }));
            } else {
                var result = await submitRequest();
                if (result.Success) {
                        this.setState( prev => ({
                            notifTitle: MODAL_TITLE.SUCCESS,
                            showModal: false, 
                            showValidationModal: true,
                            modalMessage: processMessage,
                            exitForm: isUpdate ? false : true
                    }));
                } else {
                    this.setState({
                        showModal: false,
                        showValidationModal: true,
                        modalMessage: result.Message,
                        exitForm: false
                    });
                }
            }
        } else {
            this.setState({
                showModal: false,
                showValidationModal: false,
                exitForm: false
            });
        }    
    }
    
    handleValidateModal = () =>{
        if(this.state.exitForm) {
            this.setState({
                showValidationModal: false,
                updateEquipment: true
            })
            this.props.closeForm();
        }else{
            this.setState({
                showValidationModal: false,
                updateEquipment: false
            })
        }
        
    }

    onClick = () =>{
        if (!isNaN(parseInt(this.props.inventoryEquipmentForm.equipmentId))
            && parseInt(this.props.inventoryEquipmentForm.equipmentId) > 0) {
            this.setState({
                showModal: true,
                notifTitle: MODAL_TITLE.UPDATE,
                acceptConf: false,
                modalMessage: EQUIPMENT_MSG.CONFIRM_UPDATE_MSG
            })

        } else {
            this.setState({isSaving: true});
            this.handleConfirmationModal("ok");
        }

    }

    getValue = (val) => {
        var value = parseInt(val);
        if (val === null || val === undefined) return 0;
        else if (isNaN(value)) return 0;
        else return value;
    }

    toLocaleLanguage = (key) => {
      const { locale } = this.props;
      if (locale === null || locale === '' || locale === undefined)
          return translation[translation['defaultLocaleLanguage']][key];
  
      return translation[locale][key];
    }

    handleDisableSaveButton = () => {
        const { inventoryEquipment, inventoryEquipmentForm, $form } = this.props
        let model = inventoryEquipmentForm.model === undefined
            || inventoryEquipmentForm.model === null
            || ((typeof inventoryEquipmentForm.model) === 'string' && inventoryEquipmentForm.model.trim() === '');
        
        let financeContractSelection = inventoryEquipment.inventoryEquipmentDropdownList.Contracts.filter(c => c.Label === inventoryEquipmentForm.vendorId);
        let financeContractSelectedValue = financeContractSelection.length > 0
            ? financeContractSelection.find(c => c.Key === inventoryEquipmentForm.contractId) === undefined
                ? 0
                : inventoryEquipmentForm.contractId
            : 0;

        let disabled = this.getValue(inventoryEquipmentForm.equipmentTypeId) === 0
            || model
            || this.getValue(inventoryEquipmentForm.equipmentStatusId) === 0
            || this.getValue(inventoryEquipmentForm.vendorId) === 0
            || this.getValue(inventoryEquipmentForm.circuitTypeId) === 0
            || financeContractSelectedValue === 0
            || this.getValue(inventoryEquipmentForm.contractId) === 0
            || isNaN(parseInt(inventoryEquipmentForm.orderCost));
        const unchanged = isObjectEqual($form.value, inventoryEquipmentForm);

        return disabled || unchanged;
    }

    getCompanyCodeOption = () => {
        const { inventoryEquipment, inventoryEquipmentForm } = this.props;
        let companyCode = (!isNaN(parseInt(inventoryEquipmentForm.costCodeId)) && parseInt(inventoryEquipmentForm.costCodeId) > 0)
            ? inventoryEquipment.inventoryEquipmentDropdownList.CostCenters.find(c => c.Key === inventoryEquipmentForm.costCodeId).Value.split('~')[1]
            : "";
        return companyCode.trim().length > 0
            ? this.state.defaultCompanyCode.filter(data => data.Value === companyCode)
            : this.state.defaultCompanyCode; 
    }

    render() {
        const { inventoryEquipment, inventoryEquipmentForm, isReadAndWrite } = this.props
        let inventoryEquipmentDetails = inventoryEquipment.inventoryEquipmentDetails;
        let companyCodeSelection = this.getCompanyCodeOption();
        let financeContractSelection = inventoryEquipment.inventoryEquipmentDropdownList.Contracts.filter(c => c.Label === inventoryEquipmentForm.vendorId);
        let financeContractSelectedValue = financeContractSelection.length > 0
            ? financeContractSelection.find(c => c.Key === inventoryEquipmentForm.contractId) === undefined
                ? 0
                : inventoryEquipmentForm.contractId
            : 0;

        if(!inventoryEquipmentForm.isLoaded && !this.props.createNew) {
            return <Loading />
        }

        return (
            <Form
            method="post" 
            role="form"
            model="inventoryEquipmentForm"
            >
            <div className="details-field-container">
               <Select
                className="form-select required"
                label={this.toLocaleLanguage('equipment_type_upper')}
                options={inventoryEquipment.inventoryEquipmentDropdownList.EquipmentTypes}
                value={inventoryEquipmentForm.equipmentTypeId}
                placeholder={PLACEHOLDER.SELECT}
                isError={this.state.isError}
                fieldProp='.equipmentTypeId'
                />
                <InputField
                className={`form-control required ${this.state.isError ? "border-red" : ""}`}
                type="text"
                label={this.toLocaleLanguage('model_upper')}
                fieldProp='.model'
                value={inventoryEquipmentForm.model}
                placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                maxLength={MAX_LENGTH.limit_100}
                />
                <InputField
                className="form-control"
                label={this.toLocaleLanguage('product_name_upper')}
                type="text"
                fieldProp='.productName'
                value={inventoryEquipmentForm.productName}
                placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                maxLength={MAX_LENGTH.limit_100}
                />
                <Select
                className="form-select required"
                label={this.toLocaleLanguage('status_capital')}
                options={inventoryEquipment.inventoryEquipmentDropdownList.EquipmentStatuses}
                value={inventoryEquipmentForm.equipmentStatusId}
                placeholder={PLACEHOLDER.SELECT}
                fieldProp='.equipmentStatusId'
                />
                <CustomSearchableSelectWrapper
                className="form-control required"
                label={this.toLocaleLanguage('vendor_upper')}
                options={inventoryEquipment.inventoryEquipmentDropdownList.Vendors}
                selected={inventoryEquipmentForm.vendorId}
                placeholder={PLACEHOLDER.SELECT}
                requiredField
                fieldProp='.vendorId'
                tagName='vendorId'
                optionLabelKey={OPTION_LABEL.KEY_VALUE}
                maxLength={MAX_LENGTH.limit_100}
                />
                <InputField
                className="form-control"
                label={this.toLocaleLanguage('currency_upper')}
                value={inventoryEquipmentDetails.currency}
                type="text"
                fieldProp='.currency'                
                disabled={true}
                />
                <CustomSearchableSelectWrapper
                 className="form-control required"
                 label={this.toLocaleLanguage('circuit_type_upper')}
                 options={inventoryEquipment.inventoryEquipmentDropdownList.CircuitTypes}
                 selected={inventoryEquipmentForm.circuitTypeId}
                 placeholder={PLACEHOLDER.SELECT}
                 requiredField
                 fieldProp='.circuitTypeId'
                 tagName='circuitTypeId'
                 optionLabelKey={OPTION_LABEL.KEY_VALUE}
                 maxLength={MAX_LENGTH.limit_100}
                 />
                 <CustomSearchableSelectWrapper
                label={this.toLocaleLanguage('contract_id_upper')}
                options={financeContractSelection}
                selected={financeContractSelectedValue}
                placeholder={PLACEHOLDER.SELECT}
                requiredField
                fieldProp='.contractId'
                tagName='contractId'
                optionLabelKey={OPTION_LABEL.KEY_VALUE}
                maxLength={MAX_LENGTH.limit_100}
                />
                <InputField
                    className="form-control required"
                    label={this.toLocaleLanguage('order_cost_upper')}
                    type="text"
                    fieldProp='inventoryEquipmentForm.orderCost'
                    value={convertToDecimal(inventoryEquipmentForm.orderCost)}   
                    placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                    inputType={DATA_TYPE.decimal}
                />
                <InputField
                    className="form-control"
                    label={this.toLocaleLanguage('discounted_order_cost_upper')}
                    type="text"
                    fieldProp='inventoryEquipmentForm.discountedOrderCost'
                    value={convertToDecimal(inventoryEquipmentForm.discountedOrderCost)}   
                    placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                    inputType={DATA_TYPE.decimal}
                />
                 <InputField
                    className="form-control"
                    label={this.toLocaleLanguage('mrc')}
                    type="text"
                    fieldProp='inventoryEquipmentForm.mrc'
                    value={inventoryEquipmentForm.mrc}
                    placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                    inputType={DATA_TYPE.decimal}
                />
                 <InputField
                    className="form-control"
                    label={this.toLocaleLanguage('nrc')}
                    type="text"
                    fieldProp='inventoryEquipmentForm.nrc'
                    value={inventoryEquipmentForm.nrc}
                    placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                    inputType={DATA_TYPE.decimal}
                />
                <CustomSearchableSelectWrapper
                label={this.toLocaleLanguage('gl_code_upper')}
                options={inventoryEquipment.inventoryEquipmentDropdownList.GlCodes}
                selected={inventoryEquipmentForm.glCodeId}
                placeholder={PLACEHOLDER.SELECT}
                fieldProp='.glCodeId'
                tagName='glCodeId'
                optionLabelKey={OPTION_LABEL.KEY_VALUE}
                maxLength={MAX_LENGTH.limit_100}
                />
                <CustomSearchableSelectWrapper
                label={this.toLocaleLanguage('capital_cost_center')}
                options={inventoryEquipment.inventoryEquipmentDropdownList.CostCenters}
                selected={inventoryEquipmentForm.costCodeId}
                placeholder={PLACEHOLDER.SELECT}
                fieldProp='.costCodeId'
                tagName='costCodeId'
                displayOption={DISPLAY_OPTION.LABEL}
                optionLabelKey={OPTION_LABEL.KEY_VALUE_LABEL}
                />
                <CustomSearchableSelectWrapper
                label={this.toLocaleLanguage('company_code_upper')}
                options={companyCodeSelection}
                selected={inventoryEquipmentForm.companyCodeId}
                placeholder={PLACEHOLDER.SELECT}
                fieldProp='.companyCodeId'
                tagName='companyCodeId'
                optionLabelKey={OPTION_LABEL.KEY_VALUE}
                />
                <Select
                className="form-select no-select__option"
                label={`VIP`}
                options={inventoryEquipment.inventoryEquipmentDropdownList.IsVIPOption}
                value={inventoryEquipmentForm.vipId} //Boolean checking 1 should be "No" and 2 Should "Yes" other value should default to No
                placeholder={PLACEHOLDER.SELECT}
                fieldProp='.vipId'
                />
                </div>
                <div className='save-btn-container'>
                <ConfirmationNotificationModal disabled={this.state.acceptConf} show={this.state.showModal} title={this.state.notifTitle} customClass="comment-notification-modal modal-text-bold" handleModal={this.handleConfirmationModal} message={this.state.modalMessage} />
                    <NotificationModal show={this.state.showValidationModal} title={this.state.notifTitle} customClass="comment-notification-modal notification-footer modal-text-bold" handleModal={this.handleValidateModal} message={this.state.modalMessage} />
                    {isReadAndWrite && <Button className='save-details-btn btn btn-primary' onClick={this.onClick} disabled = {this.handleDisableSaveButton() || this.state.isSaving} type='submit'>Save Changes</Button>}
                </div>
            </Form>
        );
    }
}
export default withRouter(
    connect(
        state => {
            const { inventoryEquipmentDetails, translation, inventoryEquipment } = state;
            const { inventoryEquipmentForm, forms: { inventoryEquipmentForm: { $form } } } = state.form;
            return {
                inventoryEquipmentForm
                , inventoryEquipmentDetails
                , inventoryEquipment
                , ...translation
                , $form
            };
        },
        dispatch => bindActionCreators(
            Object.assign({}
                , inventoryEquipmentActions),
            dispatch
        )
    )(FormView)
);
